import React from "react";
import ProjectLayout from "../layouts/ProjectLayout";
import projectsData from "../data/projectsData";

const StudioSharanOffice = () => {
  const data = projectsData.sharanDelhi;
  return <ProjectLayout {...data} />;
};

export default StudioSharanOffice;
